import type {
  AssignInterventionInput,
  PartnerIntervention,
  PartnerInterventionStatus,
  ReviewInterventionInput,
} from '@bcl/shared';
import { api } from '@/lib/api';

export type EnrichedIntervention = PartnerIntervention & {
  projectReference: string | null;
};

export type BackofficeIntervention = EnrichedIntervention & {
  partnerName: string | null;
};

export async function assignIntervention(
  input: AssignInterventionInput,
): Promise<PartnerIntervention> {
  const { data } = await api.post<PartnerIntervention>('/interventions', input);
  return data;
}

export async function listAllInterventions(
  status?: PartnerInterventionStatus,
): Promise<BackofficeIntervention[]> {
  const { data } = await api.get<BackofficeIntervention[]>('/interventions', {
    params: status ? { status } : undefined,
  });
  return data;
}

export async function listMyInterventions(): Promise<EnrichedIntervention[]> {
  const { data } = await api.get<EnrichedIntervention[]>('/interventions/mine');
  return data;
}

export async function submitInterventionReport(
  interventionId: string,
  reportContent: string,
): Promise<PartnerIntervention> {
  const { data } = await api.post<PartnerIntervention>(
    `/interventions/${interventionId}/report`,
    { reportContent },
  );
  return data;
}

export async function reviewIntervention(
  interventionId: string,
  input: ReviewInterventionInput,
): Promise<PartnerIntervention> {
  const { data } = await api.patch<PartnerIntervention>(
    `/interventions/${interventionId}/review`,
    input,
  );
  return data;
}
